import type { EndClient } from '@lensora/shared'
import { Label } from '@lensora/ui'

import { EXPIRY_OPTIONS } from './scopes'

type ExpiryValue = (typeof EXPIRY_OPTIONS)[number]['value']

interface ExpiryAndClientFieldsProps {
  expiry: ExpiryValue
  onExpiryChange: (value: ExpiryValue) => void
  endClients: EndClient[]
  restrictedClientId: string
  onRestrictedClientChange: (value: string) => void
  /** Looker Studio keys derive their restriction server-side — there's nothing to pick. */
  hideClientPicker?: boolean
}

const selectClassName =
  'flex h-9 w-full rounded border border-border bg-surface px-3 py-1 text-sm text-text shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent'

export function ExpiryAndClientFields({
  expiry,
  onExpiryChange,
  endClients,
  restrictedClientId,
  onRestrictedClientChange,
  hideClientPicker,
}: ExpiryAndClientFieldsProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="mcp-key-expiry">Expires</Label>
        <select
          id="mcp-key-expiry"
          value={expiry}
          onChange={(e) => onExpiryChange(e.target.value as ExpiryValue)}
          className={selectClassName}
        >
          {EXPIRY_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      {!hideClientPicker && endClients.length > 0 && (
        <div className="space-y-2">
          <Label htmlFor="mcp-key-client">Restrict to client (optional)</Label>
          <select
            id="mcp-key-client"
            value={restrictedClientId}
            onChange={(e) => onRestrictedClientChange(e.target.value)}
            className={selectClassName}
          >
            <option value="">All clients (unrestricted)</option>
            {endClients.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      )}
    </>
  )
}
